import React from 'react';
import { Form, Formik } from 'formik';
import { Grid, TextInput, ISpruceFieldProps, SpruceField, Button } from 'ui-toolkit';
import {
  createDefaultSearchOrderSpecification,
  ISearchOrdersSpecificationData,
} from '../../../ui-toolkit/orders/searchOrder/types/ISearchOrdersSpecification';
import { searchOrdersSpecification } from '../../../ui-toolkit/orders/searchOrder/validation/searchOrdersSpecification';

interface IOrderSearchFormProps {
  onSearchOrder: (form: ISearchOrdersSpecificationData) => void;
}

export const OrderSearchForm: React.FC<IOrderSearchFormProps> = ({ onSearchOrder }) => (
  <Formik
    initialValues={createDefaultSearchOrderSpecification()}
    isInitialValid={true}
    validationSchema={searchOrdersSpecification([], [])}
    onSubmit={(values, formikHelpers) => {
      onSearchOrder(values);
    }}
    onReset={(values, formikHelpers) => {
      formikHelpers.setValues(createDefaultSearchOrderSpecification());
      onSearchOrder(createDefaultSearchOrderSpecification());
    }}
  >
    {({ values, handleSubmit, isValid }) => (
      <Form onSubmit={handleSubmit}>
        <Grid templateColumns={'1fr min-content 1fr'}>
          <SpruceField name={'fileNumber'}>
            {({ field }: ISpruceFieldProps) => (
              <TextInput
                {...field}
                onBlur={() => field.onChange(field.value ? field.value.trim() : field.value)}
                placeholder={'Search by Order ID'}
              />
            )}
          </SpruceField>
          <Button intent={'primary'} type={'submit'}>
            Search
          </Button>
        </Grid>
        <Button intent={'ghost'} isInline type={'reset'}>
          Clear Search
        </Button>
      </Form>
    )}
  </Formik>
);
